import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Medal } from '@element-plus/icons-vue';
import { ElMessage } from 'element-plus';
import { computed, reactive, Ref, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import CustomModal from '@/components/CustomModal.vue';
import { Member, MemberRole } from '@/Member/member.entity';
import MemberService from '@/Member/member.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateMemberModal',
  emits: ["created", "cancel"],
  setup(__props, { emit }) {



const { t } = useI18n();

const form = reactive({
    email: '',
    firstName: '',
    lastName: '',
    role: MemberRole.USER,
});

const loading: Ref<boolean> = ref(false);

const isFormValid = computed(
    () => form.email.trim() !== '' && form.firstName.trim() !== '' && form.lastName.trim() !== '',
);

const handleCreate = async (): Promise<void> => {
    loading.value = true;
    try {
        const memberService = new MemberService();
        const member = await memberService.create(form);
        emit('created', member);
    } catch (error) {
        const { message } = error as { message: string };
        ElMessage.error(message);
    } finally {
        loading.value = false;
    }
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(CustomModal, {
    width: "750px",
    onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('cancel')))
  }, {
    "modal-header": _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('listMembers.addMember')), 1)
    ]),
    "modal-footer": _withCtx(() => [
      _createVNode(_component_el_button, {
        size: "small",
        class: "button is-radius-small has-text-weight-semibold",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('cancel')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('listMembers.cancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        disabled: !isFormValid.value,
        loading: loading.value,
        size: "small",
        class: "button is-primary is-radius-small has-text-weight-semibold",
        onClick: handleCreate
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('listMembers.create')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "loading"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        model: form,
        "label-width": "120px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _unref(t)('listMembers.email'),
            prop: "email",
            required: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.email) = $event)),
                type: "email"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(t)('listMembers.firstName'),
            prop: "firstName",
            required: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.firstName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.firstName) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(t)('listMembers.lastName'),
            prop: "lastName",
            required: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.lastName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.lastName) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(t)('listMembers.role'),
            prop: "role",
            required: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: form.role,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.role) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_button, {
                    label: _unref(MemberRole).USER
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('listMembers.roles.user')), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_radio_button, {
                    label: _unref(MemberRole).EXPERT
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('listMembers.roles.expert')), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_radio_button, {
                    label: _unref(MemberRole).SUPERVISOR
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('listMembers.roles.supervisor')) + " ", 1),
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Medal))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_radio_button, {
                    label: _unref(MemberRole).ADMIN
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('listMembers.roles.admin')) + " ", 1),
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Medal))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }))
}
}

})